import * as React from "react";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import EventService from "services/EventService";
import Store from "common/store";
import { makeStyles, Paper, Typography } from "@material-ui/core";
import { Colors } from "styles/Colors";
import { SetLoading } from "common/components/Loader/Loader";
import FatButton from "common/components/FatButton/FatButton";
import { toast } from "react-toastify";
import { games } from "common/constants/Games";

const propKeys = {
	events: StoreKeys.ADMIN.EVENT_MANAGER.EVENTS,
};

const gameTag = (gameId) =>
	games.find((g) => g.id === gameId)?.prefix?.toUpperCase() ?? "?";

const useStyles = makeStyles((theme) => ({
	paper: {
		color: Colors.primary,
		backgroundColor: Colors.panel,
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	row: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(1),
	},
	note: {
		marginBottom: theme.spacing(2),
		opacity: 0.8,
	},
}));

function EventManagerC({ events }) {
	const classes = useStyles();

	React.useEffect(() => {
		if (!events) {
			SetLoading(true, "Loading Events");
			EventService.getActiveEvents().then((loaded) => {
				Store.set(StoreKeys.ADMIN.EVENT_MANAGER.EVENTS, loaded);
				SetLoading(false);
			});
		}
	}, [events]);

	const syncEvent = async (eventId) => {
		try {
			SetLoading(true, "Syncing");
			await EventService.syncNow(eventId);
			SetLoading(false);
			toast("Sync triggered.", { type: "success" });
		} catch (error) {
			SetLoading(false);
			const message =
				typeof error === "string" ? error : "Sync failed - check logs.";
			toast(message, { type: "error" });
		}
	};

	const hasEvents = Array.isArray(events) && events.length > 0;

	return (
		<Paper className={classes.paper} elevation={3}>
			<Typography>Active Events</Typography>
			<Typography variant="body2" className={classes.note}>
				Check an event's sync status in Discord with /event-sync-status.
			</Typography>
			{hasEvents ? (
				<div style={{ overflowY: "scroll", maxHeight: 400 }}>
					{events.map((e) => (
						<div className={classes.row} key={e.id}>
							<Typography>
								[{gameTag(e.gameId)}] {e.nameOverride || e.name} (#{e.id})
							</Typography>
							<FatButton
								primary
								text="Force Sync"
								onClick={() => {
									syncEvent(e.id);
								}}
							/>
						</div>
					))}
				</div>
			) : (
				<Typography>There are no active events to sync.</Typography>
			)}
		</Paper>
	);
}

export default function EventManager(props) {
	return connect(<EventManagerC />, propKeys, props);
}
